enum InterestCalculationType {
    Flat = "FLAT",
    DecliningBalance = "DECLINING_BALANCE",
    DecliningBalanceEqualInstallments = "DECLINING_BALANCE_EQUAL_INSTALLMENTS"
}
export default InterestCalculationType